export default function(node, x0, y0, x1, y1) {
  this.node = node;
  this.x0 = x0;
  this.y0 = y0;
  this.x1 = x1;
  this.y1 = y1;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-quadtree/src/quad.js
// module id = 221
// module chunks = 0